import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

import url from '../../constants/config';
import notFound from '../../assets/notFound.png';

import './RecentlyViewed.scss';

/** imageBase64 is a ready-to-use data URL string from the backend */
const getPlayerPhoto = imageBase64 => imageBase64 || notFound;

const RecentlyViewed = () => {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const history = useHistory();

  useEffect(() => {
    let cancelled = false;

    const fetchRecentlyViewed = async () => {
      try {
        const token = window.localStorage.getItem('authorization');
        if (!token) {
          setIsLoading(false);
          return;
        }
        const { data } = await axios.get(`${url}/coach/recently-viewed?limit=6`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!cancelled) {
          setItems(data.players || []);
        }
      } catch (err) {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    fetchRecentlyViewed();
    return () => { cancelled = true; };
  }, []);

  // ── Loading ──────────────────────────────────────────────────
  if (isLoading) {
    return (
      <div className="rv">
        <div className="rv__header">
          <h3 className="rv__title">
            <i className="fas fa-history" /> Recently Viewed
          </h3>
        </div>
        <div className="rv__loading">
          <div className="rv__loading-dot" />
          <div className="rv__loading-dot" />
          <div className="rv__loading-dot" />
        </div>
      </div>
    );
  }

  // ── Error ────────────────────────────────────────────────────
  if (error) {
    return null; // Silent fallback – don't break the dashboard
  }

  // ── Empty ────────────────────────────────────────────────────
  if (!items.length) {
    return (
      <div className="rv">
        <div className="rv__header">
          <h3 className="rv__title">
            <i className="fas fa-history" /> Recently Viewed
          </h3>
        </div>
        <div className="rv__empty">
          <i className="far fa-eye" />
          <span>No recently viewed players yet</span>
        </div>
      </div>
    );
  }

  // ── Content: vertical list ───────────────────────────────────
  return (
    <div className="rv">
      <div className="rv__header">
        <h3 className="rv__title">
          <i className="fas fa-history" /> Recently Viewed
        </h3>
        <span className="rv__count">{items.length}</span>
      </div>

      <div className="rv__list">
        {items.map(({ playerId, player }) => (
          <div
            key={playerId}
            className="rv__row"
            onClick={() =>
              history.push({
                pathname: `/available-players/${playerId}`,
                state: { source: 'recently_viewed' },
              })
            }
          >
            <div className="rv__row-avatar">
              <img
                src={getPlayerPhoto(player.imageBase64)}
                alt={`${player.firstName} ${player.lastName}`}
              />
              {player.transfer && <span className="rv__row-transfer">T</span>}
            </div>
            <div className="rv__row-info">
              <span className="rv__row-name">
                {player.firstName} {player.lastName}
              </span>
              <span className="rv__row-meta">
                {player.sport}
                {player.position?.length ? ` · ${player.position[0]}` : ''}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentlyViewed;
